/*
 * @Author: your name
 * @Date: 2019-11-08 16:36:07
 * @LastEditTime: 2019-11-19 21:47:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\collectFolder\UCCollectFolderJs.js
 */
export const UCCollectFolderEvents=
{   
    UCCollectFolderList_event_itemClick:"UCCollectFolderList_event_itemClick",
    

    UCFormCollectFolder_event_addSucceed:"UCFormCollectFolder_event_addSucceed",
    
    
    UCFormCollectFolder_event_updateSucceed:"UCFormCollectFolder_event_updateSucceed",

    UCCollectItemList_event_nodeCheckdStatusChange:"UCCollectItemList_event_nodeCheckdStatusChange",

    
    UCCollectItemList_event_deleteNode:"UCCollectItemList_event_deleteNode",

}


export const UCCollectFolderConsts=
{
    headerOperationTypes:{
        folder_add_new:"folder_add_new",
        
        back_to_all_folder:"back_to_all_folder",
        
        folder_add_new_desc:"新建文件夹",
        
        back_to_all_folder_desc:"全部",
    },

}

